import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { ItemRow } from '@models/item';
import { useTranslation } from 'react-i18next';

interface Props {
    item: ItemRow;
}

function ItemImage({ item }:Props) {
    const { itemImageShape } = useAppCustom().items;
    const { thumbnailUrl, isSoldOut } = item;
    const { t } = useTranslation('items');
    return (
        <Container shape={itemImageShape}>
            <ThumbnailImage src={thumbnailUrl}
                width={120}
                height={120}
                alt={t('item.imageAlt')} />
            {isSoldOut && (
                <SoldOutWrapper>
                    <SoldOutContainer>
                        <SoldOutBg/>
                        <SoldOutText size='s' fontWeight='bold'>
                            {t('item.soldOut')}
                        </SoldOutText>
                    </SoldOutContainer>
                </SoldOutWrapper>
            )}
        </Container>
    );
}

const Container = styled.div<{shape: 'RECTANGLE' | 'CIRCLE'}>`
    align-items: center;
    aspect-ratio: 1;
    background-color: white;
    border-radius: ${(props) => (props.shape === 'RECTANGLE' ? '12px' : '50%')};
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.10);
    display: flex;
    justify-content: center;
    max-width: 100%;
    overflow: hidden;
    width: 100%;
    transition: 200ms;
`;

const ThumbnailImage = styled(Image)`
    height: 100%;
    object-fit: cover;
    width: 100%;
`;

const SoldOutWrapper = styled.div`
    position: absolute;
`;

const SoldOutContainer = styled.div`
    align-items: center;
    display: flex;
    height: 24px;
    justify-content: center;
    position: relative;
    transform: rotate(-18deg);
    width: 88px;
`;

const SoldOutBg = styled.div`
    background-color: var(--color-primary);
    height: 100%;
    opacity: .66;
    position: absolute;
    width: 100%;
`;

const SoldOutText = styled(Text)`
    font-size: 11px !important;
    line-height: 11px !important;
    position: relative;
    color: var(--color-button-text);
`;

export default ItemImage;
